import "./RemoteRevenueManagerForHire.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Contact from "./sections/Contact";
import RevenueServices from "./sections/RevenueServices";
import RevenueFaq from "./sections/RevenueFaq";
import StrategicRevenue from "./sections/StrategicRevenue";
import Footer from "@/reusable_sections/Footer";
export default function RemoteRevenueManagerForHirePage() {
  return <div>
      <Header />
      <Hero />
      <Contact />
      <RevenueServices />
      <RevenueFaq />
      <StrategicRevenue />
      <Footer />
    </div>;
}